module.exports = __webpack_public_path__ + "static/media/scheme6.653b88ca.png";